import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { CookieOptions } from 'angular2-cookie/core';
import { ContentHeaders } from '../common/headers';
import { AppSettings } from '../common/app.settings';
import { ApiResult } from '../models/apiresult.model';
import 'rxjs/add/operator/map';

import { PrivilegesModel } from '../models/privileges.model';

@Injectable()
export class PrivilegesService {
    private privileges: PrivilegesModel;
    private apiController = 'Privileges';

    constructor(
        private http: Http,
        private contentHeaders: ContentHeaders,
        private cookieService: CookieService) {
    }

    private getCoockieOptions(): CookieOptions {
        const cookieOptions: CookieOptions = new CookieOptions;
        if (!(window.location.href.indexOf('localhost') > 0)) {
            cookieOptions.secure = true;
        }

        return cookieOptions;
    }

    getPrivileges(): Promise<PrivilegesModel> {
        return this.http.get(
                AppSettings.apiEndPoint + '/' + this.apiController,
                { headers: this.contentHeaders.headers }
            )
            .toPromise()
            .then((response: Response) => {
                this.privileges = response.json();
                return response.json();
            })
            .catch(this.handleErrorPromise);
    }

    setPrivileges(): void {
        const cookieOptions = this.getCoockieOptions();
        this.cookieService.put('menu', this.privileges.menuEntries.join(','), cookieOptions);
    }

    hasMenuPrivileges(): boolean {
        if (this.cookieService.get('menu') === undefined) {
            return false;
        }

        return true;
    }

    setMenuPrivileges(): void {
        const cookieOptions = this.getCoockieOptions();
        this.cookieService.put('menu', this.privileges.menuEntries.join(','), cookieOptions);
    }

    setResetPassword(): Promise<ApiResult> {
        return this.http.post(
            AppSettings.apiEndPoint + this.apiController + '/SetResetPassword',
                {},
                { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    isAuthorized(menuEntry: string): boolean {

        if (!this.hasMenuPrivileges()) {
            return false;
        }

        const menuEntries = this.cookieService.get('menu').split(',');
        return menuEntries.indexOf(menuEntry) !== -1;
    }

    logOut(): void {
        this.removePrivileges();
    }

    private removePrivileges(): void {
        this.cookieService.remove('menu');
    }

    private handleErrorPromise(error: any): Promise<void> {
        try {
            error = JSON.parse(error._body);
        } catch (e) {
        }

        const errMsg = error.errorMessage
            ? error.errorMessage
            : error.message
            ? error.message
            : error._body
            ? error._body
            : error.status
            ? `${error.status} - ${error.statusText}`
            : 'unknown server error';

        return Promise.reject(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/privileges.service.ts